//Use  meteo blue to fetch current temperature in celcius of munich
//and current weather condition (rain, sun, cloudy, etc)

// @CF : add api key 

import React, { useState, useEffect } from 'react';
import { ReactComponent as SunnyIcon } from "../assets/icons/weather/sunny.svg";
import { ReactComponent as CloudyIcon } from "../assets/icons/weather/cloudy.svg";
import { ReactComponent as RainyIcon } from "../assets/icons/weather/rainy.svg";
import { ReactComponent as SnowingIcon } from "../assets/icons/weather/cloudy_snowing.svg";
import { ReactComponent as PartlyCloudyDayIcon } from "../assets/icons/weather/partly_cloudy_day.svg";
import { getSecrets } from "../api/secrets";


//night icons in case change times.
import { ReactComponent as NightIcon } from "../assets/icons/weather/night.svg"; 
import { ReactComponent as PartlyCloudyNightIcon } from "../assets/icons/weather/partly_cloudy_night.svg";


const WeatherReportV2 = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchWeatherData() {
      try {
        setLoading(true);

//         // Wait for the secrets to be retrieved
//         const secrets = await getSecrets();
// 
//         if (!secrets || !secrets.METEO_BLUE_API_KEY) {
//           throw new Error("MeteoBlue API key not found in secrets.");
//         }
// 
//         const apiKey = secrets.METEO_BLUE_API_KEY;
//         const lat = 48.1351; // Munich latitude
//         const lon = 11.5820; // Munich longitude
// 
//         const response = await fetch(
//           `https://my.meteoblue.com/packages/current?lat=${lat}&lon=${lon}&apikey=${apiKey}`
//         );
// 
//         if (!response.ok) {
//           throw new Error(`Error fetching weather data: ${response.status}`);
//         }
// 
//         const usefulData = await response.json();
        const serverAddress = process.env.REACT_APP_SERVER_ADDRESS
        const apiUrl = `${serverAddress}/api/get_weather`;    // `http://127.0.0.1:5000/api/get_weather` to run locally
        const response = await fetch(apiUrl);
        const usefulData = await response.json();
        console.log(usefulData);

        setData(usefulData);
      } catch (error) {
        console.error("An error occurred:", error);
        setError(error.message);
        setData("Unavailable");
      } finally {
        setLoading(false);
      }
    }

    fetchWeatherData(); // Call the async function inside useEffect
  }, []);

  return (
    <div className="search-bar-panel-weather">
      <div id="weather-report">
        <div className="weather-icon">

          {/* render icons based on pictocode */}
          {[1].includes(data?.pictocode) && <SunnyIcon />}
          {[2, 3, 7, 10].includes(data?.pictocode) && (
            <PartlyCloudyDayIcon />
          )}
          {[4, 5].includes(data?.pictocode) && <CloudyIcon />}
          {[6, 7, 8, 11, 12, 14, 16].includes(
            data?.pictocode
          ) && <RainyIcon />}
          {[9, 13, 15, 17].includes(data?.pictocode) && (
            <SnowingIcon />
          )}
        </div>

        {loading && <h5>Loading...</h5>}
        {!loading && (
          <h5>Feels like {Math.round(data?.temperature)} °C</h5>
        )}
      </div>

      <div className="flex-row-filler"></div>
    </div>
  );
};

export default WeatherReportV2;